import UbahSeleksiVendor from './UbahSeleksiVendor'

export default UbahSeleksiVendor